let menu = async function (api){
let interessi_menu = [
    {
      href: "/category-list/5",
      title: "Modifica Categorie",
      abilities: "user-create",
    },
  ];

  if (await api.user.can("interessi-view")) {
    let interessi = await api.categories.index(5);

    for (let interesse of interessi.data.children) {
      interessi_menu.push({
        href:
          "/interessi-list/" +
          interesse.id +
          "/" +
          interesse.contents.it.title,
        title: interesse.contents.it.title,
        icon: "fa fa-list",
        abilities: "interessi-view",
      });
    }
  }

return [
    {
      title: "UTENTI",
      icon: "ti-user",
      abilities: "user-view",

      child: [
        {
          href: "/users",
          title: "Lista Utenti",
          icon: "fa fa-list",

          abilities: "user-view",
          child: [
            {
              href: "/users/new",
              title: "Nuovo Utente",
              icon: "fa fa-plus",
              abilities: "user-view",
            },
          ],
        },
        {
          href: "/users/roles",
          title: "Ruoli",
          icon: "ti-ruler",
          abilities: "user-view",
        },
        {
          href: "/users/redazioni",
          title: "Redazioni",
          icon: "ti-ruler",
          abilities: "user-view",
        },
      ],
    },
    {
      title: "EVENTI",
      icon: "fa fa-calendar",
      abilities: "event-view",

      child: [
        {
          href: "/events",
          title: "Lista Eventi",
          icon: "fa fa-list",
          abilities: "event-view",
        },
        {
          href: "/events/new",
          title: "Nuovo Evento",
          icon: "fa fa-plus",
          abilities: "event-create",
        },
        {
          href: "/category-list/1",
          title: "Categorie Eventi",
          abilities: "user-create",
        },
      ],
    },
     {
          title: "BLOG",
          icon: "fa fa-pencil-square-o",
          abilities: "blog-view",
          child: [
            {
              href: "/blog",
              title: "Lista Articoli",
              icon: "fa fa-list",
              abilities: "blog-view",

            },
            {
              href: "/blog/new",
              title: "Nuovo Articolo",
              icon: "fa fa-plus",
              abilities: "blog-create"
            },
          ],
        },
    /* {
          title: "SOGGIORNO",
          icon: "fa fa-suitcase",
          abilities: "soggiorno-view",

          child: [
            {
              href: "/soggiorno",
              title: "Lista Proposte",
              icon: "fa fa-list",
              abilities: "soggiorno-view",

            },
            {
              href: "/soggiorno/new",
              title: "Nuova Proposta",
              icon: "fa fa-plus",
              abilities: "soggiorno-create",

            },
          ],
        }, */
        /* ESPERIENZE */
        {
          title: "ESPERIENZE",
          icon: "fa fa-camera",
          abilities: "esperienze-view",
          child: [
            {
              href: "/esperienze",
              title: "Lista Esperienze",
              icon: "fa fa-list",
              abilities: "esperienze-view",
            },
            {
              href: "/esperienze/new",
              title: "Nuova Esperienza",
              icon: "fa fa-plus",
              abilities: "esperienze-create",
            },
          ],
        },
    {
      title: "NEWS",
      icon: "fa fa-newspaper-o",
      abilities: "news-view",

      child: [
        {
          href: "/news",
          title: "Lista News",
          icon: "fa fa-list",
          abilities: "news-view",
        },
        {
          href: "/news/new",
          title: "Nuova News",
          icon: "fa fa-plus",
          abilities: "news-create",
        },
      ],
    },
    {
      title: "IAT",
      icon: "fa fa-info-circle",
      abilities: "iat-view",

      child: [
        {
          href: "/iat",
          title: "Lista IAT",
          icon: "fa fa-list",
          abilities: "iat-view",
        },
        {
          href: "/iat/new",
          title: "Nuovo IAT",
          icon: "fa fa-plus",
          abilities: "iat-create",
        },
      ],
    },
    {
      title: "ITINERARI",
      icon: "fa fa-list",
      abilities: "itinerary-view",

      child: [
        {
          href: "/category-list/6",
          title: "Target",
          abilities: "user-create",
        },
        {
          href: "/category-list/4",
          title: "Durata Itinerari",
          abilities: "user-create",
        },
        {
          href: "/itinerary",
          title: "Lista Itinerari",
          icon: "fa fa-list",
          abilities: "itinerary-view",
        },
        {
          href: "/itinerary/new",
          title: "Nuovo Itinerario",
          icon: "fa fa-plus",
          abilities: "itinerary-create",
        },
      ],
    },
    /*{
      title: "VIA EMILIA",
      icon: "fa fa-list",
      abilities: "user-create",

      child: [
        {
          href: "/viaemilia",
          title: "Lista Itinerari",
          icon: "fa fa-list",
          abilities: "user-create",
        },
        {
          href: "/viaemilia/new",
          title: "Nuovo Itinerario",
          icon: "fa fa-plus",
          abilities: "user-create",
        },
      ],
    }, */
    {
      title: "LOCALITA'",
      icon: "fa fa-globe",
      abilities: "localita-view",

      child: [
        {
          href: "/locality",
          title: "Lista Località",
          icon: "fa fa-list",
          abilities: "localita-view",
        },
        {
          href: "/locality/new",
          title: "Nuova Località",
          icon: "fa fa-plus",
          abilities: "localita-create",
        },
      ],
    },
    {
      title: "VALLI",
      icon: "fa fa-pencil-square-o",
      abilities: "valli-view",
      child: [
        {
          href: "/valli",
          title: "Lista Valli",
          icon: "fa fa-list",
          abilities: "valli-view",

        },
        {
          href: "/valle/new",
          title: "Nuova valle",
          icon: "fa fa-plus",
          abilities: "valli-create"
        },
      ],
    },
    {
      title: "INTERESSI",
      icon: "fa fa-lightbulb-o",
      abilities: "interessi-view",
      child: interessi_menu,
    },
  /*  {
      title: "ORGANIZZA",
      icon: "fa fa-lightbulb-o",
      abilities: "operatori-view",

      child: [
        {
          href: "/operatori",
          title: "Lista Operatori",
          icon: "fa fa-list",
          abilities: "operatori-view",

        },
        {
          href: "/operatori/new",
          title: "Nuovo Operatore",
          icon: "fa fa-plus",
          abilities: "operatori-view",

        },
      ],
    }, */
    {
      title: "DOWNLOAD",
      icon: "fa fa-download",
      abilities: "download-view",

      child: [
        {
          href: "/download-list",
          title: "Lista Download",
          icon: "fa fa-list",
          abilities: "download-view",
        },
        {
          href: "/download/new/download",
          title: "Nuovo Download",
          icon: "fa fa-plus",
          abilities: "download-create",
        },
      ],
    },

    /*  {
      title: "OPEN DATA",
      icon: "fa fa-database",
      abilities: "opendata-view",

      child: [
        {
          href: "/opendata-list",
          title: "Lista Open Data",
          icon: "fa fa-list",
          abilities: "opendata-view",

        },
        {
          href: "/opendata/new/opendata",
          title: "Nuovo Open Data",
          icon: "fa fa-plus",
          abilities: "opendata-create",

        },
      ],
    }, */
 /*   {
      title: "TREKKSOFT",
      icon: "fa fa-calendar",
      abilities: "user-create",

      href: "/trekksoft-list",
    }, */
 /*   {
      title: "MAKEXP",
      icon: "fa fa-calendar",
      abilities: "event-view",

      href: "/makexp-list",
    }, */


    {
      href: "/gallery-frame-entity/true",
      title: "MEDIA",
      icon: "fa fa-picture-o",
      abilities: "media-create",
    },
    {
      href: "/allegati",
      title: "ALLEGATI",
      icon: "fa fa-file-o",
      abilities: "media-create",
    },
    {
      href: "/natale-capodanno",
      title: "FESTIVITÀ ",
      icon: "fa fa-file-o",
      abilities: "media-create",
    },
    {
      title: "PAGINE",
      icon: "fa fa-file-text-o",
      abilities: "user-create", //SOLO AMMINISTRATORE

      child: [
        {
          href: "/page",
          title: "Lista",
          icon: "fa fa-file-text-o",
          abilities: "user-create", //SOLO AMMINISTRATORE
        }
      ],
    },
    {
      href: "/punti-interesse",
      title: "LUOGHI",
      icon: "fa fa-map-marker",
      abilities: "luoghi-view", //SOLO AMMINISTRATORE
    },
    {
      title: "WEBCAM",
      icon: "fa fa-video-camera",
      abilities: "webcam-view",

      child: [
        {
          href: "/webcam-list",
          title: "Lista Webcam",
          icon: "fa fa-list",
          abilities: "webcam-view",
        },

        {
          href: "/webcam/new/webcam",
          title: "Nuova Webcam",
          icon: "fa fa-plus",
          abilities: "webcam-create",
        },
      ],
    },
    {
      title: "IMPOSTAZIONI",
      icon: "fa fa-cog",
      abilities: "user-create", //TODO: Gestire il ruolo meglio.

      child: [
        {
          href: "/home-settings",
          title: "Home",
          icon: "fa fa-list",
          abilities: "user-create",
        },
        {
          href: "/home-settings-extra",
          title: "Extra",
          icon: "fa fa-list",
          abilities: "user-create",
        },
        {
          href: "/error404-list",
          title: "Errori 404",
          icon: "fa fa-list",
          abilities: "user-create",
        },
        {
          href: "/tags",
          title: "Tags",
          icon: "fa fa-list",
          abilities: "user-create",
        },
        {
          href: "/instagram-settings",
          title: "Instagram",
          icon: "fa fa-instagram",
          abilities: "user-create",
        },
      ],
    },
    {
      title: "PROFILO",
      icon: "fa fa-user",
      abilities: true,

      child: [
        {
          href: "/user/profile",
          title: "Profilo Utente",
          abilities: true,
          icon: "fa fa-cogs",
        },
        {
          href: "/user/logout",
          title: "Logout",
          icon: "fa fa-sign-out",
          abilities: true,
        },
      ],
    },
  ];
}

export { menu };
export default menu;
